function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as p } from "react/jsx-runtime";
import * as c from "react";
import { isAndroid as i, isChrome as l } from "./utils/platform.js";
import { useDisableBodyScroll as y, useTheme as h } from "./hooks.js";
import { getPrefixedDataAttributes as b } from "./utils/dom.js";
const x = {
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 12,
    outline: "none",
    WebkitTapHighlightColor: "transparent"
}, g = (param)=>{
    let { onPress: o , children: a , className: n , style: s , disableScroll: f = !1 , dataAttributes: u  } = param;
    const [d, r] = c.useState(!0);
    y(f);
    const { platformOverrides: e  } = h(), m = (t)=>{
        t.button === 2 && o && o(t);
    };
    return /* @__PURE__ */ p("div", _object_spread_props(_object_spread({
        "data-overlay": "true"
    }, b(u, "Overlay")), {
        style: _object_spread({}, x, s),
        className: n,
        onPointerDown: (t)=>{
            t.target.dataset.overlay && o && (a && i(e) && l(e) ? (r(!1), t.stopPropagation()) : o(t));
        },
        onClick: (t)=>{
            t.target.dataset.overlay && o && a && i(e) && l(e) && (r(!0), o(t));
        },
        "touch-action": "auto",
        onContextMenu: m,
        role: "button",
        tabIndex: 0,
        children: d && a
    }));
}, S = g;
export { S as default };
